import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Permission } from './types/permission.type';

/**
 * Fetches a single permission by uid.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the permission.
 * @returns OperationResultWithData wrapping `Permission`.
 */
export const getPermission = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.get<OperationResultWithData<Permission>>(formatString(Uri.permissions.byUid, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
